<template>
  <v-row no-gutters>
    <v-col cols="12" md="9">
      <base-text-field
        class="mb-6"
        clearable
        flat
        hide-details
        :placeholder="placeholder"
        search-icon
        solo
        :value="text"
        @click:clear="$emit('clear')"
        @input="$emit('change', $event)"
        @keydown.enter="$emit('submit')"
      />
    </v-col>
    <v-col cols="12" md="3">
      <v-btn
        class="py-7 btn-width"
        color="primary"
        depressed
        @click="$emit('submit')"
      >
        <v-icon>mdi-magnify</v-icon> Search
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'SearchTable',

  props: {
    placeholder: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
.btn-width {
  width: 100%;
}
</style>
